import 'scss/solutions/AI-smart-media-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'

$(function () {
  $(document).on('mouseenter', '.solutions-item-advantage .solutions-item-content li', function (e) {
    let $this = $(e.currentTarget)

    $this.siblings().removeClass('active')
    $this.addClass('active')
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/AI-smart-media-solution.js